// SEPA Verification of Payee (OM-16532).

export enum VopOutcome {
  Match = 'MATCH',
  CloseMatch = 'CLOSE_MATCH',
  NoMatch = 'NO_MATCH',
  NotAvailable = 'NOT_AVAILABLE',
}

// TODO: placeholder codes — swap for BE's real ones once confirmed.
export enum VopStatusCode {
  Match = 9001,
  CloseMatch = 9002,
  NoMatch = 9003,
  NotAvailable = 9005,
}

export interface IRegisteredName {
  firstName?: string;
  lastName?: string;
  fullName?: string;
}

export interface IVop {
  statusCode: number;
  registeredName?: IRegisteredName | null;
  fingerprint?: string;
  promptRequired?: boolean;
}

export enum VopConsent {
  None = 'None',
  Match = 'Match',
  CloseMatchNameUpdated = 'CloseMatchNameUpdated',
  CloseMatchProceededWithoutUpdate = 'CloseMatchProceededWithoutUpdate',
  NoMatchProceededWithUpdate = 'NoMatchProceededWithUpdate',
  NoMatchProceededWithoutUpdate = 'NoMatchProceededWithoutUpdate',
  NotAvailableProceeded = 'NotAvailableProceeded',
}

const CODE_TO_OUTCOME: { [code: number]: VopOutcome } = {
  [VopStatusCode.Match]: VopOutcome.Match,
  [VopStatusCode.CloseMatch]: VopOutcome.CloseMatch,
  [VopStatusCode.NoMatch]: VopOutcome.NoMatch,
  [VopStatusCode.NotAvailable]: VopOutcome.NotAvailable,
};

export const getVopOutcome = (vop: IVop): VopOutcome | null => {
  if (!vop || vop.statusCode == null)
    return null;
  return CODE_TO_OUTCOME[vop.statusCode] || null;
};



// WEBPACK FOOTER //
// ./src/model/types/vop-type.ts